import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import ToggleButtonGroup from 'components/consumer/ToggleButtonGroup';
import ToggleTabGroup from 'components/consumer/ToggleTabGroup';
import Placeholder from 'components/consumer/Placeholder';
import MobileAndTabletOnly from '../MobileAndTabletOnly';
import DesktopOnly from '../DesktopOnly';
const ImportantToggle = t0 => {
  const $ = _c(11);
  const {
    "aria-label": ariaLabel,
    loading: t1,
    items: t2,
    onClick: t3,
    selected,
    isLayoutRevamp: t4
  } = t0;
  const loading = t1 === undefined ? false : t1;
  let t5;
  if ($[0] !== t2) {
    t5 = t2 === undefined ? [] : t2;
    $[0] = t2;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const items = t5;
  const onClick = t3 === undefined ? _temp : t3;
  const isLayoutRevamp = t4 === undefined ? false : t4;
  let t6;
  if ($[2] !== ariaLabel || $[3] !== isLayoutRevamp || $[4] !== items || $[5] !== onClick || $[6] !== selected) {
    t6 = isLayoutRevamp ? <ToggleTabGroup aria-label={ariaLabel || ""} selectedTab={selected} items={items.map(t7 => {
      const {
        contentId,
        disabled,
        id,
        label,
        infoTooltip,
        infoTooltipContent
      } = t7;
      return {
        contentId,
        disabled: !!disabled,
        id,
        onClick: () => {
          onClick(id);
        },
        label,
        infoTooltip: !!infoTooltip,
        infoTooltipContent: infoTooltipContent || ""
      };
    })} variant="underline" /> : <><MobileAndTabletOnly><div className="min-h-[48px] lg:mt-3 lg:[border-top:1px_solid_#f1f1f1] lg:[border-bottom:1px_solid_#ccc] lg:hidden"><ToggleTabGroup aria-label={ariaLabel || ""} selectedTab={selected} items={items.map(t8 => {
            const {
              contentId: contentId_0,
              id: id_0,
              label: label_0,
              infoTooltip: infoTooltip_0,
              infoTooltipContent: infoTooltipContent_0
            } = t8;
            return {
              contentId: contentId_0,
              id: id_0,
              onClick: () => {
                onClick(id_0);
              },
              label: label_0,
              infoTooltip: !!infoTooltip_0,
              infoTooltipContent: infoTooltipContent_0 || ""
            };
          })} styling="ImportantToggle" /></div></MobileAndTabletOnly><DesktopOnly><div className="min-h-[48px] lg:mt-3 lg:[border-top:1px_solid_#f1f1f1] lg:[border-bottom:1px_solid_#ccc] max-[1023px]:hidden"><ToggleButtonGroup aria-label={ariaLabel || ""} selectedItem={selected} items={items.map(t9 => {
            const {
              contentId: contentId_1,
              id: id_1,
              label: label_1,
              description,
              infoTooltip: infoTooltip_1,
              infoTooltipContent: infoTooltipContent_1
            } = t9;
            return {
              contentId: contentId_1,
              id: id_1,
              onClick: () => {
                onClick(id_1);
              },
              label: label_1,
              description,
              infoTooltip: !!infoTooltip_1,
              infoTooltipContent: infoTooltipContent_1 || ""
            };
          })} styling="ImportantToggle" /></div></DesktopOnly></>;
    $[2] = ariaLabel;
    $[3] = isLayoutRevamp;
    $[4] = items;
    $[5] = onClick;
    $[6] = selected;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== loading || $[9] !== t6) {
    t7 = <Placeholder loading={loading} type="rect" className="rounded mx-0 my-4 min-h-[45px] lg:m-0 lg:min-h-[60px]">{t6}</Placeholder>;
    $[8] = loading;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  return t7;
};
ImportantToggle.propTypes = {
  'aria-label': PropTypes.string,
  loading: PropTypes.bool,
  items: PropTypes.arrayOf(PropTypes.shape({
    contentId: PropTypes.string.isRequired,
    id: PropTypes.string,
    label: PropTypes.string,
    description: PropTypes.string,
    // Layout revamp only
    disabled: PropTypes.bool,
    infoTooltip: PropTypes.bool,
    infoTooltipContent: PropTypes.string
  })),
  onClick: PropTypes.func,
  selected: PropTypes.string,
  isLayoutRevamp: PropTypes.bool
};
export default ImportantToggle;
function _temp() {}